import { takeLatest } from 'redux-saga/effects'
import {
  APP_SERVED,
  APP_RENDERED,
  APP_DEV_MODE_TOGGLE,
  USER_SUCCESS,
  USER_FAILURE
} from 'actions'

const initialState = {
  served: 0,
  rendered: 0,
  devMode: false
}

/** ACTIONS
 --------------------------------------------------------------- */
export const appRendered = (date) => ({ type: APP_RENDERED, rendered: date })
export const appServed = (date) => ({ type: APP_SERVED, served: date })
export const devModeToggle = () => ({ type: APP_DEV_MODE_TOGGLE })

/** REDUCERS
 --------------------------------------------------------------- */
export const appReducers = (state = initialState, action) => {
  switch (action.type) {
    case APP_SERVED: {
      const { served } = action
      return { ...state, served }
    }

    case APP_RENDERED: {
      const { rendered } = action
      return { ...state, rendered }
    }

    case APP_DEV_MODE_TOGGLE: {
      const devModeState = state.devMode
      return { ...state, devMode: !devModeState }
    }

    default:
      return state
  }
}

/** SAGAS :: WATCHERS
 --------------------------------------------------------------- */

export const appSagas = []

/** SAGA :: RESPONDERS
 --------------------------------------------------------------- */
